import React from "react";
import './style.scss';
import { useEventContext } from "../../context/EventContext";

export default ({ block }) => {
    const { event } = useEventContext();

    const image = block?.imageUrl || event.moduleTheme?.poster;

    if (!image) return null;

    return (
        <section className={"page-block poster-block"}>
            <img alt="" src={image} />
        </section>
    );
}
